import React, { useEffect, useState } from "react";
import styled from "styled-components";

import BookTable from "./components/BookTable";
import BookRoom from "./components/BookRoom";
import BookOther from "./components/BookOther";
import TypeSelector from "./components/TypeSelector";
import { TableProvider } from "./store/table";

const Wrapper = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  width: 100%;
  max-width: calc(705px + 5%);
  height: 100%;
  min-height: 100vh;
  max-height: 100%;
  padding-left: 5%;
  background: #1c1c1c;
  background-clip: content-box;
  overflow: auto;
  font-family: Poppins, serif;
  transition: 0.4s ease-in-out;
  transform: ${(props) =>
    props.active ? "translateX(0)" : "translateX(100%)"};
  opacity: ${(props) => (props.active ? "1" : "0")};

  @supports (-webkit-touch-callout: none) {
    min-height: -webkit-fill-available;

    @media (max-width: 500px) {
      -webkit-overflow-scrolling: touch;
    }
  }
`;


const Actions = styled.aside`
  display: flex;
  justify-content: flex-end;
  padding: 5px 20px;
`;

const Close = styled.button`
  position: relative;
  width: 30px;
  height: 30px;
  opacity: 0.8;
  padding: 0;
  background: 0;
  &:hover {
    opacity: 1;
  }

  &:before,
  &:after {
    position: absolute;
    left: 7px;
    content: " ";
    height: 30px;
    width: 1.5px;
    top: 0;
    background-color: rgb(203 199 199);
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

const App = ({ venueId, endpoint, optionalPanels }) => {
  const [type, setType] = useState("book-a-table");
  const [active, setActive] = useState(false);

  const openHandler = (event) => {
    const { detail: { initialType } } = event;

    if (["book-a-room", "book-a-table", "general"].includes(initialType)) {
      setType(initialType);
    }

    setActive(true);
  }
  const closeHandler = () => setActive(false);

  useEffect(() => {
    window.addEventListener("openWidget", openHandler, false);
    return function cleanup() {
      window.removeEventListener("openWidget", openHandler);
    };
  });

  useEffect(() => {
    window.addEventListener("closeWidget", closeHandler, false);
    return function cleanup() {
      window.removeEventListener("closeWidget", closeHandler);
    };
  });

  const getPanelType = () => {
    if (type === "book-a-table") return "Book a Table";
    if (type === "book-a-room") return "Book a Room";
    // eslint-disable-next-line react/prop-types
    return optionalPanels.general_label || "Call Us";
  };

  return (
    <Wrapper active={active}>
      <Actions>
        <Close onClick={window.closeDmnBookingWidget} />
      </Actions>
      <TableProvider
        venueId={venueId}
        endpoint={endpoint}
        isActive={active}
        panelType={getPanelType()}
      >
        <TypeSelector
          optionalPanels={optionalPanels}
          set={setType}
          type={type}
        />
        {type === "book-a-table" && <BookTable />}
        {type === "book-a-room" && <BookRoom optionalPanels={optionalPanels} />}
        {type === "general" && <BookOther optionalPanels={optionalPanels} />}
      </TableProvider>
    </Wrapper>
  );
};

export default App;
